import React from "react";

function About() {
  return (
    <div class="container py-10">
      <div class="wrapper bg-gray-50">
        <div class="pictur">
          <img src="./about.png" alt="" className="w-full h-full" />
        </div>
        <div class="text-content">
          <h3>our Name</h3>
          <h1>main idea</h1>
          <p>
            Green earth, also known as terre verte and Verona green, is an
            inorganic pigment derived from the minerals celadonite and
            glauconite. Sourc
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
